/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { useIntl } from 'react-intl'
//import { KTSVG } from '../../../../helpers'
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
import { SidebarMenuItem } from './SidebarMenuItem'
//import { useAuth } from '../../../../../app/modules/auth'

const SidebarMenuMain = () => {
  const intl = useIntl()
  // const { currentUser } = useAuth()
  // var manu_ids = currentUser && currentUser.menu_ids;
  // console.log(manu_ids);

  console.log('kt-auth-react-v==', localStorage.getItem('kt-auth-react-v'));
  var user = localStorage.getItem('kt-auth-react-v');
  var myUser = JSON.parse(user ? user : '{}');
  var manu_ids = myUser && myUser.menu_ids;

  return (

    <>
      {manu_ids && manu_ids.match('11') &&
        <SidebarMenuItem
          to='/dashboard'
          icon='/media/icons/duotune/art/art002.svg'
          title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
          fontIcon='bi-app-indicator'
        />
      }
      {manu_ids && manu_ids.match('12') &&
        <SidebarMenuItemWithSub
          to='/apps/item'
          title='Item management'
          fontIcon=''
          icon='/media/icons/duotune/ecommerce/ecm001.svg'
        >
          <SidebarMenuItem to='/apps/item/item-management/item' title='Item' hasBullet={true} />
        </SidebarMenuItemWithSub>
      }
      {manu_ids && (manu_ids.match('13') || manu_ids.match('14') || manu_ids.match('15') || manu_ids.match('16')) &&
        (<SidebarMenuItemWithSub
          to='/apps/order'
          title='Approvals'
          fontIcon=''
          icon='/media/icons/duotune/ecommerce/ecm001.svg'
        >
          {manu_ids.match('13') && <SidebarMenuItem to='/apps/order/order-management/order' title='Order' hasBullet={true} />}
          {manu_ids.match('14') && <SidebarMenuItem to='/apps/order/return-order-management/returnOrder' title='Return' hasBullet={true} />}
          {manu_ids.match('15') && <SidebarMenuItem to='/apps/user/leave-management/leave' title='Leave' hasBullet={true} />}
          {manu_ids.match('16') && <SidebarMenuItem to='/apps/expense/expense-entry/expense' title='Expense' hasBullet={true} />}
        </SidebarMenuItemWithSub>)
      }
      {manu_ids && manu_ids.match('17') &&
        <SidebarMenuItemWithSub
          to='/apps/user'
          title='User management'
          fontIcon='users'
          icon='/media/icons/duotune/communication/com006.svg'
        >
          <SidebarMenuItem to='/apps/user/user-management/user' title='User' hasBullet={true} />
        </SidebarMenuItemWithSub>
      }
   
   {manu_ids && (
       manu_ids.match('28') || 
       manu_ids.match('44') ||
       manu_ids.match('45') || 
       manu_ids.match('46') ||
       manu_ids.match('47') || 
       manu_ids.match('48') ||
       manu_ids.match('49') || 
       manu_ids.match('50') ||
       manu_ids.match('51') || 
       manu_ids.match('52') ||
       manu_ids.match('53') || 
       manu_ids.match('54') ||
       manu_ids.match('55') || 
       manu_ids.match('56') ||
       manu_ids.match('57') || 
       manu_ids.match('58')
      ) &&
        <>
          <SidebarMenuItemWithSub
            to='/apps/master'
            title='Master management  '
            fontIcon='bi-archive'
            icon='/media/icons/duotune/general/gen022.svg'
          >
           
            {manu_ids && (manu_ids.match('28')) && <SidebarMenuItem to='/apps/master/warehouse-management/warehouse' title='Warehouse ' hasBullet={true} />}
            {manu_ids && (manu_ids.match('44')) && <SidebarMenuItem to='/apps/master/dealer-management/dealer' title='Dealer' hasBullet={true} />}
            {manu_ids && (manu_ids.match('45')) && <SidebarMenuItem to='/apps/master/zone-management/zone' title='Zone' hasBullet={true} />}
            {manu_ids && (manu_ids.match('46')) && <SidebarMenuItem to='/apps/master/beat-management/beat' title='Beat' hasBullet={true} />}
            {manu_ids && (manu_ids.match('54')) && <SidebarMenuItem to='/apps/master/outlet-management/outlet' title='Outlet' hasBullet={true} />}
            {/*<SidebarMenuItem to='/apps/user-management/users' title='Users' hasBullet={true} />*/}
            {/* <SidebarMenuItem to='/apps/master/area-management/area' title='Area' hasBullet={true} /> */}
            {manu_ids && (manu_ids.match('47')) && <SidebarMenuItem to='/apps/master/designation-management/designation' title='Designation' hasBullet={true} />}
            {manu_ids && (manu_ids.match('48')) && <SidebarMenuItem to='/apps/master/role-management/role' title='Role' hasBullet={true} />}
            {manu_ids && (manu_ids.match('49')) && <SidebarMenuItem to='/apps/master/division-management/division' title='Division' hasBullet={true} />}
            {manu_ids && (manu_ids.match('50')) && <SidebarMenuItem to='/apps/master/scheme-management/scheme' title='Scheme' hasBullet={true} />}
            {manu_ids && (manu_ids.match('51')) && <SidebarMenuItem to='/apps/master/department-management/department' title='Department' hasBullet={true} />}
            {manu_ids && (manu_ids.match('52')) && <SidebarMenuItem to='/apps/master/outletCategory-management/outletCategory' title='Outlet Category' hasBullet={true} />}
            {manu_ids && (manu_ids.match('53')) && <SidebarMenuItem to='/apps/master/expense-management/expense' title='Expense' hasBullet={true} />}
            
            {manu_ids && (manu_ids.match('55')) && <SidebarMenuItem to='/apps/master/outletCustomer-management/outletCustomer' title='Outlet Customer' hasBullet={true} />}
            {manu_ids && (manu_ids.match('56')) && <SidebarMenuItem to='/apps/master/state-management/state' title='State' hasBullet={true} />}
            {manu_ids && (manu_ids.match('57')) && <SidebarMenuItem to='/apps/master/city-management/city' title='City' hasBullet={true} />}
            {manu_ids && (manu_ids.match('58')) && <SidebarMenuItem to='/apps/master/district-management/district' title='District' hasBullet={true} />}

          </SidebarMenuItemWithSub>

          {/* <SidebarMenuItemWithSub
            to='/apps/master'
            title='Outlet management'
            fontIcon='bi-archive'
            icon='/media/icons/duotune/general/gen022.svg'
          >
      
          </SidebarMenuItemWithSub>
          <SidebarMenuItemWithSub
            to='/apps/master'
            title='Address management'
            fontIcon='bi-archive'
            icon='/media/icons/duotune/general/gen022.svg'
          >
     
          </SidebarMenuItemWithSub>
          */}
        </>
}

      {manu_ids && (manu_ids.match('18') || manu_ids.match('19') || manu_ids.match('20')) &&
        (<SidebarMenuItemWithSub
          to='/apps/mapping'
          title='Mapping management'
          fontIcon='bi-archive'
          icon='/media/icons/duotune/maps/map009.svg'
        >
          {manu_ids.match('18') && <SidebarMenuItem to='/apps/mapping/beat/beat-management/beat' title='Outlet Transfer' hasBullet={true} />}
          {manu_ids.match('19') && <SidebarMenuItem to='/apps/mapping/user/user-management/user' title='Beat Transfer' hasBullet={true} />}
          {manu_ids.match('20') && <SidebarMenuItem to='/apps/mapping/mtp/mtp-management/mtp' title='Mtp-management' hasBullet={true} />}
        </SidebarMenuItemWithSub>)
      }
      {/* <SidebarMenuItemWithSub to='/apps/setting' title='Setting management' fontIcon='bi-archive'
        icon='/media/icons/duotune/coding/cod001.svg'>
        <SidebarMenuItem to='/apps/setting/role-permission-management/role-permission' title='Role Permission' hasBullet={true} />
      </SidebarMenuItemWithSub> */}
      {/* {manu_ids && manu_ids.match('20') &&
        <SidebarMenuItemWithSub
          to='/apps/expense'
          title='Expense entry'
          fontIcon='report'
          icon='/media/icons/duotune/communication/com006.svg'
        >
          
        </SidebarMenuItemWithSub>
      } */}
      {manu_ids && (manu_ids.match('21') || manu_ids.match('22') || manu_ids.match('23') || manu_ids.match('24') || manu_ids.match('25') || manu_ids.match('26') || manu_ids.match('27')) &&
        (<SidebarMenuItemWithSub
          to='/apps/reports'
          title='Reports'
          fontIcon='report'
          icon='/media/icons/duotune/files/fil003.svg'
        >
          {manu_ids.match('21') && <SidebarMenuItem to='/apps/report/user-attendance/attendance' title='Day-wise attendance ' hasBullet={true} />}
          {manu_ids.match('22') && <SidebarMenuItem to='/apps/report/attendance/attendance' title='Attendance (Muster Roll)' hasBullet={true} />}
          {manu_ids.match('23') && <SidebarMenuItem to='/apps/report/daySummary/daySummary' title='Day summary - orders' hasBullet={true} />}
          {manu_ids.match('24') && <SidebarMenuItem to='/apps/report/performanceSummary/performanceSummary' title='Performance summary' hasBullet={true} />}
          {manu_ids.match('25') && <SidebarMenuItem to='apps/report/activitySummary/activitySummary' title='Day summary - activities' hasBullet={true} />}
          {manu_ids.match('26') && <SidebarMenuItem to='apps/report/skuOrderDetails/skuOrderDetails' title='Sku order details' hasBullet={true} />}
          {manu_ids.match('27') && <SidebarMenuItem to='apps/report/expense/expense' title='Expense' hasBullet={true} />}
          {manu_ids.match('27') && <SidebarMenuItem to='apps/report/orderLocation/' title='Order location' hasBullet={true} />}
        </SidebarMenuItemWithSub>)
      }




      {/*<SidebarMenuItem
        to='/builder'
        icon='/media/icons/duotune/general/gen019.svg'
        title='Layout Builder'
        fontIcon='bi-layers'
      />
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Crafted</span>
        </div>
      </div>
      <SidebarMenuItemWithSub
        to='/crafted/pages'
        title='Pages'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen022.svg'
      >
        <SidebarMenuItemWithSub to='/crafted/pages/profile' title='Profile' hasBullet={true}>
          <SidebarMenuItem to='/crafted/pages/profile/overview' title='Overview' hasBullet={true} />
          <SidebarMenuItem to='/crafted/pages/profile/projects' title='Projects' hasBullet={true} />
          <SidebarMenuItem
            to='/crafted/pages/profile/campaigns'
            title='Campaigns'
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/crafted/pages/profile/documents'
            title='Documents'
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/crafted/pages/profile/connections'
            title='Connections'
            hasBullet={true}
          />
        </SidebarMenuItemWithSub>

        <SidebarMenuItemWithSub to='/crafted/pages/wizards' title='Wizards' hasBullet={true}>
          <SidebarMenuItem
            to='/crafted/pages/wizards/horizontal'
            title='Horizontal'
            hasBullet={true}
          />
          <SidebarMenuItem to='/crafted/pages/wizards/vertical' title='Vertical' hasBullet={true} />
        </SidebarMenuItemWithSub>
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to='/crafted/accounts'
        title='Accounts'
        icon='/media/icons/duotune/communication/com006.svg'
        fontIcon='bi-person'
      >
        <SidebarMenuItem to='/crafted/account/overview' title='Overview' hasBullet={true} />
        <SidebarMenuItem to='/crafted/account/settings' title='Settings' hasBullet={true} />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to='/error'
        title='Errors'
        fontIcon='bi-sticky'
        icon='/media/icons/duotune/general/gen040.svg'
      >
        <SidebarMenuItem to='/error/404' title='Error 404' hasBullet={true} />
        <SidebarMenuItem to='/error/500' title='Error 500' hasBullet={true} />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to='/crafted/widgets'
        title='Widgets'
        icon='/media/icons/duotune/general/gen025.svg'
        fontIcon='bi-layers'
      >
        <SidebarMenuItem to='/crafted/widgets/lists' title='Lists' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/statistics' title='Statistics' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/charts' title='Charts' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/mixed' title='Mixed' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/tables' title='Tables' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/feeds' title='Feeds' hasBullet={true} />
      </SidebarMenuItemWithSub>
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Apps</span>
        </div>
      </div>*/}
      {/* <SidebarMenuItemWithSub
        to='/apps/chat'
        title='Chat'
        fontIcon='bi-chat-left'
        icon='/media/icons/duotune/communication/com012.svg'
      >
        <SidebarMenuItem to='/apps/chat/private-chat' title='Private Chat' hasBullet={true} />
        <SidebarMenuItem to='/apps/chat/group-chat' title='Group Chart' hasBullet={true} />
        <SidebarMenuItem to='/apps/chat/drawer-chat' title='Drawer Chart' hasBullet={true} />
      </SidebarMenuItemWithSub> */}





      {/* <SidebarMenuItem
        to='/apps/user-management/users'
        icon='/media/icons/duotune/general/gen051.svg'
        title='User management'
        fontIcon='bi-layers'
      /> */}








      {/* <div className='menu-item'>
        <a
          target='_blank'
          className='menu-link'
          href={process.env.REACT_APP_PREVIEW_DOCS_URL + '/docs/changelog'}
        >
          <span className='menu-icon'>
            <KTSVG path='/media/icons/duotune/general/gen005.svg' className='svg-icon-2' />
          </span>
          <span className='menu-title'>Changelog {process.env.REACT_APP_VERSION}</span>
        </a>
      </div> */}
    </>
  )
}

export { SidebarMenuMain }
